import React from "react";
import { Box } from "@mui/material";
import DashboardKpiCards from "../components/dashboard/DashboardKpiCards";
import GlobalShipmentMap from "../components/dashboard/GlobalShipmentMap";
import DashboardAlerts from "../components/dashboard/DashboardAlerts";
import ShipmentValueDistribution from "../components/dashboard/ShipmentValueDistribution";
import TopSuppliersByValue from "../components/dashboard/TopSuppliersByValue";

const DashboardPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100%",
        p: "32px",
        bgcolor: "#F7F7F7",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      {/* KPI Cards (includes title section) */}
      <Box sx={{ mb: "16px" }}>
        <DashboardKpiCards />
      </Box>

      {/* Map + Alerts row */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: "16px",
      }}
      >
        <Box data-tutorial-step="dashboard-map" sx={{ flex: 2, minWidth: 0 }}>
          <GlobalShipmentMap />
        </Box>
        <Box data-tutorial-step="dashboard-alerts" sx={{ flex: 1, minWidth: 0 }}>
          <DashboardAlerts />
        </Box>
      </Box>

      {/* Charts row */}
      <Box
        data-tutorial-step="dashboard-charts"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: "16px",
        }}
      >
        <Box sx={{ flex: { xs: "1 1 auto", lg: "0 0 38%" }, minWidth: 0 }}>
          <ShipmentValueDistribution />
        </Box>
        <Box sx={{ flex: { xs: "1 1 auto", lg: "0 0 62%" }, minWidth: 0 }}>
          <TopSuppliersByValue />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardPage;
